import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';

const TextDriftAmplitudeYListItem = (props) => {
    const { amplitudeY, index, updateTextElement } = props;

    const onAmplitudeYChange = (value) => updateTextElement(index, { drift: { amplitudeY: value } });

    return (
        <SliderListItem
            title='Y Distance'
            displayMultiplier={2}
            value={amplitudeY}
            min={0}
            max={100}
            step={1}
            onValueChange={onAmplitudeYChange}
            toolTip='Vertical movement distance.'
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { amplitudeY } = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    return { amplitudeY };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftAmplitudeYListItem);
